export default {
  name: 'dashify:ResponsiveGridLayout',
  title: 'ResponsiveGridLayout',
  owner: 'System',
  solution: '',
  tags: ['DASHUI'],
  createdAt: 'Aug 16, 2023, 12:00 PM',
  updatedAt: 'Oct 12, 2023, 09:03 AM',
  spec: {
    props: {},
    defaults: {
      className: 'layout',
      breakpoints: { lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 },
      cols: { lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 },
      layouts: {},
      rowHeight: 45,
      containerPadding: [10, 10],
      margin: [10, 10],
    },
    view: [['dashify:RGLResponsiveGridLayout', '/${ $defaultsDeep({}, props, defaults) }', '/${ children }']],
  },
};
